import logoTitle from './logoTitle';
import k_404Page from './404Page';
import k_403Page from './403Page';
import serviceUnavailable from './serviceUnavailable';
import errorPage from './errorPage';
import featureUnavailablePage from './featureUnavailablePage';
import phrases from './phrases';
import navigation from './navigation';
import systemRoles from './systemRoles';
import notificationPermissions from './notificationPermissions';
import notificationEvents from './notificationEvents';
import learningUserPage from './learningUserPage';
import learningAdminPage from './learningAdminPage';
import userListSearch from './userListSearch';
import passingListPage from './passingListPage';
import userRating from './userRating';
import userCardInfo from './userCardInfo';
import systemList from './systemList';
import projectPage from './projectPage';
import passing from './passing';
import analytics from './analytics';
import login from './login';
import settingsUser from './settingsUser';
import validation from './validation';
import updatePassword from './updatePassword';
import settings from './settings';
import projectRoles from './projectRoles';
import invitation from './invitation';
import createUnit from './createUnit';
import fileUpload from './fileUpload';
import ad from './ad';
import createProject from './createProject';
import systemSpecificationsPage from './systemSpecificationsPage';
import managerFilter from './managerFilter';
import uploadImagePreview from './uploadImagePreview';
import passingResults from './passingResults';
import codeEditor from './codeEditor';
import finalResults from './finalResults';
import buttonsText from './buttonsText';
import contentTransfer from './contentTransfer';
import learningReport from './learningReport';
import pageTitles from './pageTitles';

const blocks = {
  logoTitle: logoTitle,
  '404Page': k_404Page,
  '403Page': k_403Page,
  serviceUnavailable: serviceUnavailable,
  errorPage: errorPage,
  featureUnavailablePage: featureUnavailablePage,
  phrases: phrases,
  navigation: navigation,
  systemRoles: systemRoles,
  notificationPermissions: notificationPermissions,
  notificationEvents: notificationEvents,
  learningUserPage: learningUserPage,
  learningAdminPage: learningAdminPage,
  userListSearch: userListSearch,
  passingListPage: passingListPage,
  userRating: userRating,
  userCardInfo: userCardInfo,
  systemList: systemList,
  projectPage: projectPage,
  passing: passing,
  analytics: analytics,
  login: login,
  settingsUser: settingsUser,
  validation: validation,
  updatePassword: updatePassword,
  settings: settings,
  projectRoles: projectRoles,
  invitation: invitation,
  createUnit: createUnit,
  fileUpload: fileUpload,
  ad: ad,
  createProject: createProject,
  systemSpecificationsPage: systemSpecificationsPage,
  managerFilter: managerFilter,
  uploadImagePreview: uploadImagePreview,
  passingResults: passingResults,
  codeEditor: codeEditor,
  finalResults: finalResults,
  buttonsText: buttonsText,
  contentTransfer: contentTransfer,
  learningReport: learningReport,
  pageTitles: pageTitles,
};

export default blocks;
